import * as styles from './styles'

type NewsInputProps = {
    required?: boolean
    placeholder: string
    textColor: string
    textSize: number
    value: any
    valueName: string
    handleChange: (name: string, value: any) => void
    error?: boolean
    errorMessage?: string
    maxLength?: number
    setError?: (a: boolean) => void
    margin?: string
}

export const NewsInput = ({
    required,
    placeholder,
    textColor,
    textSize,
    value,
    valueName,
    handleChange,
    error,
    errorMessage,
    maxLength,
    setError,
    margin
}: NewsInputProps) => {
    const handleOnChange = (ev: any) => {
        if (setError) {
            setError(false)
        }
        handleChange(valueName, ev.target.value)
    }
    return (
        <>
            <styles.NewsInput
                type="text"
                maxLength={maxLength}
                placeholder={required ? placeholder + '*' : placeholder}
                textColor={textColor}
                textSize={textSize}
                value={value}
                onChange={ev => handleOnChange(ev)}
                error={error || false}
                margin={margin || '0'}
            />
            {error && <styles.TextError>{errorMessage}*</styles.TextError>}
        </>
    )
}
